import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeLawsuit } from '../entities/employee-lawsuit';

@Injectable()
export class EmployeeLawsuitService extends BaseCrudService<EmployeeLawsuit> {

  public uri = '/api/employeeLawsuit/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeLawsuitService');
  }

  buildSentence(entity?: EmployeeLawsuit, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentNumber ?
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
          `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.percentage ?
          `percentage${QueryOperator.Contain}${entity.percentage}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.accountNumber ?
          `accountNumber${QueryOperator.Contain}${entity.accountNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.fixedAmount ?
          `fixedAmount${QueryOperator.Contain}${entity.fixedAmount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.employeeRelative && entity.employeeRelative.id) {
        query = query.concat(
          `employeeRelative.id${QueryOperator.Equal}${entity.employeeRelative.id}${QueryOperator.Split}`
        );
      }
      if (entity.calculationOrder && entity.calculationOrder.id) {
        query = query.concat(
          `calculationOrder.id${QueryOperator.Equal}${entity.calculationOrder.id}${QueryOperator.Split}`
        );
      }
      if (entity.acountType && entity.acountType.id) {
        query = query.concat(
          `acountType.id${QueryOperator.Equal}${entity.acountType.id}${QueryOperator.Split}`
        );
      }
      if (entity.bank && entity.bank.id) {
        query = query.concat(
          `bank.id${QueryOperator.Equal}${entity.bank.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-lawsuit.service.ts